<template>
  <v-row>
    <v-col cols="12" class="py-0">
      <ComponentsFixedBar :minimized-side-menu="minimizedSideMenu"
                          :title="$t('general.calls')"/>
    </v-col>

    <v-col cols="12"
           class="d-flex align-center"
           style="padding-top: 50px">

      <template v-if="loadingCalls">
        <LoadingComponent :circleSize="80"
                          :message="$t('general.loadingCalls')"
                          height="100%" />
      </template>

      <template v-else-if="!loadingCalls && (!personCalls || !personCalls.length)">
        <div class="d-flex justify-center align-center" style="width: 100%; height: 160px">
          <div class="px-4 py-0">
            <div class="pb-2 d-flex justify-center align-center">
              <v-icon :color="mainColor"
                      size="50px"
                      class="mr-2">
                mdi-phone-remove
              </v-icon>
            </div>
            <span
              class="kbGray--text text-center d-block"
              style="font-size: 18px; width: 100%; margin: 0 auto">
              {{ $t('general.noPersonCallsFound') }}
            </span>
          </div>
        </div>
      </template>

      <template v-else>
        <CallsList :calls="personCalls" />
      </template>

    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import notifications from '@/libs/notifications'
import CallsList from '@/pages/App/Calls/CallsList'
import ComponentsFixedBar from '@/pages/App/People/dialogs/ViewUser/ComponentsFixedBar'
import LoadingComponent from '@/components/ui/LoadingComponent'
export default {
  components: { CallsList, ComponentsFixedBar, LoadingComponent },
  computed: {
    ...mapState({
      personCalls: state => state.calls.personCalls,
      selectedUser: state => state.users.selectedUser,
      userKeybe: state => state.auth.userKeybe
    })
  },
  created () {
    this.getPersonCalls()
  },
  data () {
    return {
      addingUserToList: false,
      connectingCall: false,
      loadingCalls: false,
      selectedList: ''
    }
  },
  methods: {
    async getPersonCalls () {
      try {
        const data = { recordId: this.selectedUser.userId }
        this.loadingCalls = true
        await this.$store.dispatch('getPersonCalls', {
          companyId: this.$store.getters.companyUuid,
          appId: this.$store.getters.appUuid,
          data
        })
        this.loadingCalls = false
      } catch (e) {
        this.loadingCalls = false
        notifications.error(e)
      }
    }
  },
  props: {
    mainColor: {
      type: String
    },
    minimizedSideMenu: {
      type: Boolean,
      required: true
    },
    userId: {
      type: String
    }
  }
}
</script>
